export const reportPageFieldFocusProps = {
  _focus: { borderColor: "gray.500", boxShadow: "none" },
  _focusVisible: { borderColor: "gray.500", boxShadow: "none" },
} as const;

const reportCheckboxControlBase = {
  borderRadius: "2px",
  borderColor: "gray.500",
  bg: "transparent",
  _hover: {
    bg: "transparent",
    borderColor: "gray.500",
  },
  "&[data-hover]": {
    bg: "transparent",
    borderColor: "gray.500",
  },
} as const;

const reportCheckboxControlChecked = {
  bg: "gray.500",
  borderColor: "gray.500",
  color: "white",
  _hover: {
    bg: "gray.500",
    borderColor: "gray.500",
    color: "white",
  },
  "&[data-hover]": {
    bg: "gray.500",
    borderColor: "gray.500",
    color: "white",
  },
} as const;

/** Apply on a single `Checkbox` via `sx`. */
export const reportCheckboxSx = {
  ".chakra-checkbox__control": reportCheckboxControlBase,
  ".chakra-checkbox__control[data-checked], .chakra-checkbox__control[aria-checked=true]":
    reportCheckboxControlChecked,
} as const;

const reportCheckboxDescendantSx = {
  "& .chakra-checkbox__control": reportCheckboxControlBase,
  "& .chakra-checkbox__control[data-checked], & .chakra-checkbox__control[aria-checked=true]":
    reportCheckboxControlChecked,
} as const;

export const reportPageFieldFocusSx = {
  "& .chakra-input:focus, & .chakra-input:focus-visible, & .chakra-input[data-focus], & .chakra-textarea:focus, & .chakra-textarea:focus-visible, & .chakra-textarea[data-focus], & .chakra-select:focus, & .chakra-select:focus-visible, & .chakra-select[data-focus]":
    {
      borderColor: "gray.500",
      boxShadow: "none",
    },
  "& .chakra-menu__menu-button:focus, & .chakra-menu__menu-button:focus-visible, & .chakra-menu__menu-button[data-focus]":
    {
      borderColor: "gray.500",
      boxShadow: "none",
    },
  "& select:focus, & select:focus-visible": {
    borderColor: "gray.500",
    outline: "none",
    boxShadow: "none",
  },
  ...reportCheckboxDescendantSx,
} as const;
